import { Orientation } from '@/modules'
import Facade from '../../Facade'
import { ApplicationResizer } from './ApplicationResizer'

export class ApplicationMobileResizer extends ApplicationResizer {
    protected detectOrientation(): Orientation {
        const viewportWidth = window.visualViewport?.width
        const viewportHeight = window.visualViewport?.height

        const width =
            typeof viewportWidth === 'number' && viewportWidth > 0
                ? viewportWidth
                : this._viewWrapper.clientWidth || window.innerWidth

        const height =
            typeof viewportHeight === 'number' && viewportHeight > 0
                ? viewportHeight
                : this._viewWrapper.clientHeight || window.innerHeight

        return width >= height ? Orientation.LANDSCAPE : Orientation.PORTRAIT
    }

    protected updateGameStageBounds(): void {
        if (!Facade.displayConfig) return
        const { WORLD_WIDTH, WORLD_HEIGHT } = Facade.displayConfig.sizes[this._orientation]

        this._gameStageBounds.height = WORLD_HEIGHT
        this._gameStageBounds.width = WORLD_WIDTH
    }

    public updateWrapperBounds(): void {
        const wrapperWidth = this._viewWrapper.clientWidth
        const wrapperHeight = this._viewWrapper.clientHeight
        const viewportHeight = window.visualViewport?.height

        this._wrapperBounds.width = wrapperWidth
        this._wrapperBounds.height =
            typeof viewportHeight === 'number' && viewportHeight > 0
                ? Math.min(wrapperHeight, viewportHeight)
                : wrapperHeight
    }

    public updateCanvasSize(): void {
        const { canvasWidth, canvasHeight } = this
        const { width, height } = this._gameStageBounds

        const scale = Math.min(canvasWidth / width, canvasHeight / height)
        const cssWidth = Math.round(width * scale)
        const cssHeight = Math.round(height * scale)

        Facade.app.stage.scale.set(scale)

        if (Facade.app && Facade.app.renderer) {
            Facade.app.renderer.resize(cssWidth, cssHeight)
        }

        this._canvas.style.width = `${cssWidth}px`
        this._canvas.style.height = `${cssHeight}px`
        this._canvas.style.left = `${Math.round((canvasWidth - cssWidth) / 2)}px`
        this._canvas.style.top = `${Math.round((canvasHeight - cssHeight) / 2)}px`

        if (Facade.container) {
            if (this._orientation === Orientation.LANDSCAPE) {
                Facade.container.position.set(1065, 445.5)
            } else {
                Facade.container.position.set(550, 930)
            }
        }
    }

    public get canvasHeight(): number {
        return this._wrapperBounds.height
    }

    public get canvasWidth(): number {
        return this._wrapperBounds.width
    }

    public get resolution(): number {
        return window.devicePixelRatio
    }
}
